import { Field, Form, Formik } from "formik"
import api from "../services/api"
import FormikField from "../Components/Forms/FormikField"
import * as Yup from "yup"
import Button from "../Components/Button"
import { deleteConfirmationAtom } from "../state"
import { useAtom } from "jotai"
import { getFromPlanContent } from "../lib/plan"

const schema = Yup.object().shape({
  name: Yup.string().required("Required"),
  student_first_name: Yup.string().required("Required"),
  student_last_name: Yup.string().required("Required"),
})

function EditPlan({ onEdit, onDelete, plan }) {
  const [deleteConfirmation, setDeleteConfirmation] = useAtom(deleteConfirmationAtom)

  const onSubmit = values => {
    const { student_first_name, student_last_name, ...rest } = values
    Promise.all([
      api.updatePlan(plan.token, rest),
      api.createPlanContent({
        reset: true,
        content: [
          {
            plan_token: plan.token,
            key: "student_first_name",
            value: student_first_name,
          },
          {
            plan_token: plan.token,
            key: "student_last_name",
            value: student_last_name,
          },
        ],
      }),
    ]).then(response => {
      onEdit()
    })
  }

  const onDeleteClick = e => {
    setDeleteConfirmation(() => () => {
      api.deletePlan(plan.token).then(response => {
        onDelete()
      })
    })
  }

  return (
    <div>
      <h1 className="mb-6 text-center text-2xl font-bold">Edit Plan</h1>
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          name: plan.name,
          student_first_name: getFromPlanContent(plan, "student_first_name"),
          student_last_name: getFromPlanContent(plan, "student_last_name"),
        }}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values }) => (
          <Form>
            {plan.youth?.length === 0 && (
              <>
                <FormikField name="student_first_name" instructions={[]} title="Student First Name">
                  <Field
                    name="student_first_name"
                    placeholder="First Name"
                    className="mb-4 w-full rounded-md border p-2"
                  />
                </FormikField>
                <FormikField name="student_last_name" instructions={[]} title="Student Last Name">
                  <Field
                    name="student_last_name"
                    placeholder="Last Name"
                    className="mb-4 w-full rounded-md border p-2"
                  />
                </FormikField>
              </>
            )}
            <FormikField name="name" instructions={[]} title="Plan Name">
              <Field name="name" placeholder="Name" className="mb-4 w-full rounded-md border p-2" />
            </FormikField>
            <div className="flex items-center justify-between">
              <Button type="submit">Update</Button>
              <button className="text-xs underline" onClick={onDeleteClick}>
                Delete Plan
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default EditPlan
